// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 10) return "static/css/10.1f94a0116067c7784c23.lib.css";
	if (chunkId === 517) return "static/css/517.768824f6f30886eca30f.css";
	// return url for filenames based on template
	return undefined;
};